module.exports = __webpack_public_path__ + "img/raketa.91c51280.svg";